<!-- eslint-disable vue/no-v-html -->
<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <div class="ds1-utd-js2">
    <input ref="defaultFocus" 
           class="visuallyHidden utd-modal-default-focus" 
           aria-label="Default focus element for error notification" 
           aria-hidden="true">
    <UtdNotification
      class="utd-notification"
      tabindex="0"
      notification-mode="error">
      <template #title>
        <div class="notification-title">
          {{ errorTitle || C_ACCOUNT.FORM_MESSAGING.UNEXPECTED_ERROR }}
        </div>
      </template>
      <div v-if="showIncorrectSignIn">
        <ul id="invalidLoginMsg" class="notification-content">
          <li>Please check the spelling of your Username and Password.</li>
          <li>
            If you forgot your Username or Password:
            <a href="#" @click="emit('login-form-forgot-credentials')">click here</a>
          </li>
        </ul>
      </div>
      <div v-else-if="showMaxAttemptsMsg">
        <ul id="maxAttemptsMsg" class="notification-content">
          <li>
            You have reached the maximum number of attempts for your Username and Password.
          </li>
          <li>
            Please exit your browser and try again.
          </li>
        </ul>
      </div>
      <div v-else-if="showInvalidMergeMsg" v-html="$t('LOGIN.MERGE_RULES_ERROR')" />
      <div v-else-if="showInvalidMergeNewUserMsg" v-html="$t('LOGIN.MERGE_RULES_NEW_USER_ERROR')" />
      <div v-else-if="showInvalidMergeSameUserMsg" 
           v-html="$t('LOGIN.MERGE_RULES_SAME_USER_ERROR')" />
      <div v-else-if="showValidateAccountErrorMsg" 
           v-html="$t('LOGIN.CONSOLIDATE_VALIDATE_ACCOUNT_ERROR')" />
      <div v-else>
        <ul id="genericErrorMsg" class="notification-content">
          <li>We are sorry that there was an error in this process.</li>
          <li><UtdCustomerSupport /></li>
          <li>To restart your sign-in process, please select:
            <a id="loginFormBackLink"
               :href="C_HTTP.DEFAULT_LOGIN"
               @click="emit('login-form-sign-out')">Back</a>
          </li>
        </ul>
      </div>
    </UtdNotification>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from 'vue';
import UtdCustomerSupport from '_acaSrc/components/shared/stdlib/UtdCustomerSupport.vue';
import UtdNotification from '_acaSrc/components/shared/utd/UtdNotification.vue';
import { C_ACCOUNT, C_HTTP } from '_acaSrc/utility/constants';

const {
    errorTitle,
    errorMessage
} = defineProps({
    errorTitle: {
        type: String,
        default: ''
    },
    errorMessage: {
        type: String,
        default: ''
    }
});
const emit = defineEmits([ 'login-form-sign-out', 'login-form-forgot-credentials' ]);
const defaultFocus = ref(null);
onMounted(() => {
    nextTick(() => {
        defaultFocus.value && defaultFocus.value.focus();
    });
});

const showIncorrectSignIn = computed(() => 
    C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.INCORRECT_SIGNIN.has(errorMessage)
    || errorTitle === C_ACCOUNT.FORM_MESSAGING.LOGIN_ERROR_TITLE
);

const showMaxAttemptsMsg = computed(() => 
    C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.MAX_ATTEMPTS.has(errorMessage) 
    || errorTitle === C_ACCOUNT.FORM_MESSAGING.MAX_ATTEMPTS_TITLE
);

const showInvalidMergeMsg = computed(() => 
    C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.INVALID_MERGE.has(errorMessage)
);

const showInvalidMergeNewUserMsg = computed(() => 
    C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.NEW_USER_MERGE.has(errorMessage)
);

const showValidateAccountErrorMsg = computed(() => 
    C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.VALIDATE_ACCOUNT.has(errorMessage)
);

const showInvalidMergeSameUserMsg = computed(() => 
    C_ACCOUNT.FORM_MESSAGING.MERGE_ERROR_SETS.SAME_USER_ERROR_STATUSES.has(errorMessage)
);
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles.less';

.notification-content {
  .ds1-pl-3();
  .ds1-ma-0();
  line-height: 21px;
}
</style>